/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum OrderCompletionStatus {
  DELIVERED="DELIVERED",
MISSED="MISSED"
}

/**
* OrderCompletionStatus
*/
export const OrderCompletionStatusEnumType = types.enumeration("OrderCompletionStatus", [
        "DELIVERED",
  "MISSED",
      ])
